import { useEffect, useState } from "react";
import { getNews } from "../lib/api";
import { useSEO } from "../lib/useSEO";
import PageHero from "../components/layout/PageHero";
import CTASection from "../components/CTASection";
import { NewsCard } from "../components/Cards";
import { CardSkeletons, ErrorState } from "./Home";
import { Reveal } from "../components/motion/Reveal";

export default function News() {
  useSEO(
    "News & Updates — Suvera Academy",
    "Guides, insights and updates on studying abroad from the Suvera Academy team."
  );
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    getNews()
      .then(setNews)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main data-testid="news-page">
      <PageHero
        eyebrow="News & Updates"
        title="Insights for the Journey Ahead"
        description="Practical guidance on destinations, applications, scholarships, visas and student life abroad."
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "News" }]}
        testid="news-hero"
      />
      <section className="mx-auto max-w-[1440px] px-4 py-16 sm:px-6 lg:px-10 lg:py-24">
        {loading ? (
          <CardSkeletons count={5} />
        ) : error ? (
          <ErrorState message="News articles could not be loaded. Please refresh the page." />
        ) : (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="news-grid">
            {news.map((a, i) => (
              <Reveal key={a.slug} delay={(i % 3) * 0.06} className="h-full"><NewsCard a={a} /></Reveal>
            ))}
          </div>
        )}
      </section>
      <CTASection />
    </main>
  );
}
